import React from 'react'
import ConfigETC from "../Class/ConfigETC.json";

/* Create By Poom : 08-06-2023 */
function Timesheet_Calendarbar_ShowStatus(props) {

  const { status, title} = props;

  return (
    <>
        <i className={(status === 1 ? ConfigETC.Timesheet_Class_Reject : "") ||
                      (status === 2 ? ConfigETC.Timesheet_Class_InProgress : "") ||
                      (status === 3 ? ConfigETC.Timesheet_Class_ToRe_ToApp_App_Clearing : "") ||
                      (ConfigETC.Timesheet_Class_Blank)}
            title={title}
        />
    </>
  )
}

export default Timesheet_Calendarbar_ShowStatus